<template>
  <view class="ts-container" wx:class="{{externClass}}">
    <block wx:if="{{isLoaded}}">
      <slot name="bg-icon"></slot>
      <view class="ts-header" wx:if="{{slot.header}}">
        <ts-navbar
          wx:if="{{useDefaultNavbar && !hideNavBar}}"
          fullScreen="{{fullScreen}}"
          navbarStyle="{{navbarStyle}}"
          titleStyle="{{titleStyle}}"
          fillboxStyle="{{fillboxStyle}}"
          useDefaultBack="{{useDefaultBack}}"
          leftArrow="{{leftArrow}}"
          left="{{left}}"
          useWebBack="{{navbarUseWebBack}}"
          title="{{navbarTitle}}"
          isDropdown="{{isDropdown}}"
          isFixed="{{isFixed}}"
          dropdownStyle="{{dropdownStyle}}"
          bind:clickright="clickRight"
          bind:clickleft="clickLeft"
        >
          <view slot="right" wx:if="{{navbarUseRight}}">
            <slot name="narbar-right" />
          </view>
        </ts-navbar>
        <slot wx:else name="header"></slot>
      </view>
      <slot name="prepend"></slot>
      <view class="ts-main" wx:style="{{mainStyle}}">
        <view wx:if="{{anchorList.length}}" wx:ref="scrollerfixed" class="ts-scroller-fixed">
          <slot name="scroller-fixed"></slot>
        </view>
        <scroll-view
          class="ts-main-scroller"
          id="ts-main-scroller"
          scroll-y="{{enableScroll}}"
          scroll-top="{{scrollTop}}"
          scroll-into-view="{{scrollIntoView}}"
          bindscroll="scrollHandle"
          bindscrolltoupper="scrollToTopHandle"
          bindscrolltolower="scrollToBottomHandle"
          scroll-with-animation="{{scrollWithAnimation}}"
          refresher-enabled="{{useRefresher}}"
          refresher-default-style="{{refresherDefaultStyle}}"
          refresher-triggered="{{refresherTriggered}}"
          bindrefresherrefresh="refresherrefresh"
          bindrefresherpulling="refresherpulling"
          refresher-background="{{refresherbackground}}"
        >
          <view slot="refresher" class="pulldown">
            <image
              wx:if="{{!isRestore}}"
              src="https://pt-starimg.didistatic.com/static/starimg/img/Hc2LzFVPzU1652950957080.png"
              class="pulldown-loading"
            />
            <view class="pulldown-text">{{ refreshText }}</view>
          </view>
          <ts-polyfill-page
            wx:if="{{useBlankPage}}"
            type="{{blankPageType}}"
            loadingContext="{{loadingContext}}"
            blankButtonContext="{{blankButtonContext}}"
            blankContextTitle="{{blankContextTitle}}"
            blankContextSubTitle="{{blankContextSubTitle}}"
            loadingImageUrl="{{loadingImageUrl}}"
            blankImageUrl="{{blankImageUrl}}"
            hasButton="{{hasBlankButton}}"
            hasSubTitle="{{hasBlankSubTitle}}"
            hasTitle="{{hasBlankTitle}}"
            setBlankContext="{{setBlankContext}}"
            bind:click-button="clickButton"
            blank-title-style="{{blankTitleStyle}}"
            blank-subtitle-style="{{blankSubtitleStyle}}"
            categoryLoadingTitle="{{categoryLoadingTitle}}"
            categoryLoadingDesc="{{categoryLoadingDesc}}"
          >
            <view slot="blankContextTitle">
              <slot name="blankContext" />
            </view>
          </ts-polyfill-page>
          <slot wx:else></slot>
        </scroll-view>
      </view>
      <view class="ts-footer" wx:if="{{slot.footer}}" wx:style="{{footerStyle}}">
        <slot name="footer"></slot>
      </view>
    </block>
    <view wx:else class="skeleton-container">
      <slot name="skeleton" />
    </view>
  </view>
</template>

<script>
  import mpx, { createComponent } from '@mpxjs/core'
  import { is, throttle } from '@didi/spring-base'
  createComponent({
    properties: {
      isLoaded: {
        type: Boolean,
        value: true
      },
      layout: {
        type: Array,
        value: ['header']
      },
      externClass: {
        type: String,
        value: ''
      },
      mainStyle: {
        type: Object,
        value: {}
      },
      fullScreen: {
        type: Boolean,
        value: false
      },
      enableScroll: {
        type: Boolean,
        value: true
      },
      useDefaultNavbar: {
        type: Boolean,
        value: true
      },
      useRefresher: {
        type: Boolean,
        value: false
      },
      useDefaultBack: {
        type: Boolean,
        value: true
      },
      navbarUseRight: {
        type: Boolean,
        value: false
      },
      leftArrow: {
        type: Boolean,
        value: true
      },
      left: {
        type: String,
        value: ''
      },
      isFixed: {
        type: Boolean,
        value: false
      },
      navbarStyle: {
        type: Object,
        value: {}
      },
      fillboxStyle: {
        type: Object,
        value: {}
      },
      dropdownStyle: {
        type: Object,
        value: {}
      },
      titleStyle: {
        type: Object,
        value: {}
      },
      footerStyle: {
        type: Object,
        value: {}
      },
      refresherbackground: {
        type: String,
        value: '#1473FF'
      },
      navbarClickLeft: null,
      navbarTitle: String,
      navbarUseWebBack: {
        type: Boolean,
        value: true
      },
      // 锚点相关组件
      scrollIntoView: {
        type: String,
        value: ''
      },
      anchorList: {
        type: Array,
        value: []
      },
      scrollTop: Number,
      scrollWithAnimation: {
        type: Boolean,
        value: false
      },
      setBlankContext: {
        type: Boolean,
        value: false
      },
      blankPageType: {
        type: String,
        value: 'blank-page'
      },
      useBlankPage: {
        type: Boolean,
        value: false
      },
      loadingContext: {
        type: String,
        value: '数据加载中...'
      },
      blankButtonContext: {
        type: String,
        value: '重试'
      },
      blankContextTitle: {
        type: String,
        value: '加载失败'
      },
      blankContextSubTitle: {
        type: String,
        value: '请检查网络设置或稍后重试'
      },
      loadingImageUrl: {
        type: String,
        value: 'https://pt-starimg.didistatic.com/static/starimg/img/VY4SkVNwXT1644496067250.gif'
      },
      blankImageUrl: {
        type: String,
        value: 'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png'
      },
      hasBlankButton: {
        type: Boolean,
        value: true
      },
      hasBlankSubTitle: {
        type: Boolean,
        value: true
      },
      hasBlankTitle: {
        type: Boolean,
        value: true
      },
      blankTitleStyle: {
        type: Object,
        value: {}
      },
      blankSubtitleStyle: {
        type: Object,
        value: {}
      },
      // 是否强制重绘
      isForceUpdate: {
        type: Boolean,
        value: true
      },
      // 品类加载标题
      categoryLoadingTitle: {
        type: String,
        value: ''
      },
      // 品类加载描述
      categoryLoadingDesc: {
        type: String,
        value: ''
      }
    },
    data() {
      return {
        // mainHeight: 580
        refresherTriggered: false,
        isDropdown: false,
        isRequest: false,
        isRestore: true
      }
    },
    computed: {
      slot() {
        return this.layout.reduce((slot, key) => ((slot[key] = true), slot), {})
      },
      refresherDefaultStyle() {
        return this.useRefresher ? 'none' : 'black'
      },
      needDiffStyle() {
        return this.dropdownStyle && Object.keys(this.dropdownStyle)?.length !== 0
      },
      refreshText() {
        return this.refresherTriggered ? '正在刷新' : this.isRestore ? '' : '松开立即刷新'
      },
      hideNavBar() {
        // 微信 & 阿里小程序隐藏代码的title bar
        return is('miniprogram')
      }
    },
    pageLifetimes: {
      show: function () {
        if (this.isForceUpdate) {
          // 由于部分情况（比如其他页面弹起键盘后）,scroll-view宽高会变为0，导致页面布局错乱，重绘页面
          this.$forceUpdate()
        }
      }
    },
    ready() {
      // setTimeout(() => {
      //   this.getElement('.ts-main', (rect) => {
      //     const { height } = rect || {}
      //     this.mainHeight = height
      //   })
      // }, 500)
      this.getAnchorOffSet()
    },

    methods: {
      // 获取当前的元素节点
      getElement(ele, cb) {
        const query = mpx.createSelectorQuery().in(this)
        query.select(ele).boundingClientRect(cb).exec()
      },
      /**
       * @description: 滚动事件
       */
      scrollHandle: throttle(function (e) {
        const { scrollTop } = e.detail || {}
        this.isDropdown = !!(this.needDiffStyle && scrollTop > 50)
        this.$nextTick(() => {
          this.getAnchorOffSet()
        })
        this.triggerEvent('scrolling', e)
      }, 200),

      /**
       * @description: 滚动到顶部事件
       */
      scrollToTopHandle(e) {
        this.triggerEvent('scrolltotop', e)
      },

      /**
       * @description: 滚动到底部事件
       */
      scrollToBottomHandle(e) {
        if (this.isRequest) return
        this.isRequest = true
        this.triggerEvent('scrolltobottom', {
          e,
          done: this.scrollBottomCb
        })
      },

      /**
       * @description: 空白页按钮点击事件
       */
      clickButton() {
        this.triggerEvent('blankretry')
      },
      // getCustomMainHeight() {
      //   return this.mainHeight
      // },
      refresherrefresh() {
        this.refresherTriggered = true
        setTimeout(() => {
          this.triggerEvent('refresherrefresh', { done: this.pullDownCb })
        }, 0)
      },
      refresherpulling() {
        this.isRestore = false
      },
      pullDownCb() {
        this.refresherTriggered = false
        this.isRestore = true
      },
      scrollBottomCb() {
        this.isRequest = false
      },
      clickLeft() {
        this.triggerEvent('clickleft')
      },
      clickRight() {
        this.triggerEvent('clickright')
      },
      getAnchorOffSet() {
        if (!this.anchorList.length) return
        let containerTop
        const anchorHeight = this.$refs.scrollerfixed?._selector?.offsetHeight ?? 0
        mpx
          .createSelectorQuery()
          .in(this)
          .select('#ts-main-scroller')
          .boundingClientRect((rect) => {
            containerTop = rect.top ?? 0
          })
          .exec()
        let activeId
        this.anchorList?.reduce((min, cur) => {
          const ele = '#' + cur.id
          const query = mpx.createSelectorQuery().in(this)
          let offsetTop
          query
            .select(ele)
            .boundingClientRect((rect) => {
              offsetTop = rect.top - containerTop - anchorHeight
            })
            .exec()
          if (offsetTop < 1 && Math.abs(offsetTop) < min) {
            min = Math.abs(offsetTop)
            activeId = cur.id
          }
          return min
        }, Number.MAX_SAFE_INTEGER)
        activeId = activeId ?? this.anchorList[0].id
        this.triggerEvent('anchorchange', { id: activeId })
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .ts-container
    display flex
    flex-direction column
    height 100%
    flex 1
    flex-basis auto
    box-sizing border-box
    min-width 0
  .skeleton-container
    width 100vw
    height 100vh
    overflow hidden
  .ts-header
    display flex
    flex-direction column
  .ts-main
    flex 1
    overflow-y auto
    background #F3F4F5
  .ts-scroller-fixed
    width 100%
    position absolute
    z-index 2
    top 0
    left 0
  .ts-main-scroller
    height 100%
    width 100%
  .ts-footer
    display flex
  .pulldown
    display flex
    justify-content center
    align-items center
    width 100%
    height 56px
    background #1473FF
    .pulldown-text
      font-size 14px
      color #FFFFFF
      padding-right 28px
    .pulldown-loading
      width 20px
      height 20px
      margin-right 15px
      animation spin 2s linear infinite
    @keyframes spin
      0%
        transform rotate(0deg)
      100%
        transform rotate(360deg)
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'ts-navbar': '../ts-navbar/index',
      'ts-polyfill-page': '../ts-polyfill-page/index'
    }
  }
</script>
